//app主域名
// const host_app = "http://www.xzyds.com/";
const host_app = "http://www.xzyds.com/";

// 开发环境域名
const host_development = "https://pc.yxbds.com/";
// const host_development = "http://192.168.5.8"; //葛鹏
// const host_development = "https://test.yxbds.com/";//测试环境5

//ws链接环境x
const ws_url = "wss://ws.xzyds.com:8888";//线上
// const ws_url = "ws://192.168.5.8:8888";//测试
// const ws_url = "ws://192.168.1.36:3000";//测试线上


//测试环境
// const host_development_test = "http://192.168.5.8";//葛鹏
// const host_development_test = "https://test.yxbds.com/";
const host_development_test = "https://pc.yxbds.com/";

export default {
    // 版本
    version: "3.0.0",
    baseURL: process.env.NODE_ENV === "production" ? "https://pc.yxbds.com" :
        (process.env.NODE_ENV === "test" ? host_development_test : host_development),
    appURL: host_app,
    wsURL: ws_url,
};